import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, Box, Typography } from '@mui/material';

interface BillingAddFundsModalProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  addFundsAmount: number;
  setAddFundsAmount: (amount: number) => void;
  handleAddFunds: () => void;
}

export function BillingAddFundsModal({
  open,
  onClose,
  isLoading,
  addFundsAmount,
  setAddFundsAmount,
  handleAddFunds,
}: BillingAddFundsModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Add funds</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1.5, color: 'text.secondary' }}>
              Quick amounts
            </Typography>
            <Stack direction="row" spacing={1}>
              {[10, 25, 50].map((amount) => (
                <Button
                  key={amount}
                  onClick={() => setAddFundsAmount(amount)}
                  variant={addFundsAmount === amount ? 'contained' : 'outlined'}
                  fullWidth
                  sx={{ py: 1.5 }}
                >
                  ${amount}
                </Button>
              ))}
            </Stack>
          </Box>
          <TextField
            label="Custom Amount"
            type="number"
            value={addFundsAmount}
            onChange={(e) => setAddFundsAmount(Number(e.target.value))}
            inputProps={{ min: 10 }}
            fullWidth
            helperText="Minimum $10"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={handleAddFunds} variant="contained" disabled={isLoading || addFundsAmount < 10}>
          {isLoading ? 'Processing...' : `Add $${addFundsAmount}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
